import { english, type Localisation } from "./en";

export const englishCA: Localisation = {
  ...english,
  dateFormats: {
    ...english.dateFormats,
    datePickerLocale: "en-ca",
    timeFormat: "h:mm a",
    dayMonthFormat: "MMMM do",
    dayMonthYearFormat: "MMMM do yyyy",
    dayDateMonthYearFormat: "E, MMMM do yyyy",
    dayMonthYearTimeFormat: "MMMM do yyyy, h:mm a",
  },
};
